import { observable, action } from 'mobx';

class SessionStore {
  disconnectedCount = 0;
  @observable authUser = null;
  @observable contentSharing = null;
  @observable overlayModal = {
    show: false,
    blocking: false,
    message: '',
    component: null
  }

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @action setAuthUser = authUser => {
    this.authUser = authUser;
  };

  @action setAvatar = url => {
    // url -> base 64url....
  }

  @action setContentSharing = sahringFromPage => {
    this.contentSharing = sahringFromPage;
  }

  @action getContentSharing = () => {
    this.contentSharing;
  }

  @action clearContentSharing = () => {
    this.contentSharing = null;
  }

  @action showOverlay = (message, component, blocking) => {
    this.overlayModal = {
      show: true,
      blocking,
      message,
      component
    };
  }

  @action hideOverlay = () =>{
    this.overlayModal.show = false;
  }
}

export default SessionStore;
